import { Controller } from "@hotwired/stimulus"

// Generic popup controller that renders a dropdown as a fixed-position overlay
// so it is never clipped by overflow:hidden/auto ancestors.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._menu = this.menuTarget
    this._isOpen = false
    this._onClickOutside = this._handleClickOutside.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    if (this._isOpen) {
      this._close()
    } else {
      this._open()
    }
  }

  _open() {
    document.body.appendChild(this._menu)
    this._menu.classList.remove("hidden")
    this._position()
    this._isOpen = true
    requestAnimationFrame(() => {
      document.addEventListener("click", this._onClickOutside)
    })
  }

  _close() {
    if (!this._isOpen) return
    this._menu.classList.add("hidden")
    this.element.appendChild(this._menu)
    this._isOpen = false
    document.removeEventListener("click", this._onClickOutside)
  }

  _position() {
    const trigger = this.element.querySelector("[data-popup-trigger]")
    const rect = trigger.getBoundingClientRect()
    const menu = this._menu
    const margin = 4

    menu.style.position = "fixed"
    menu.style.zIndex = "9999"
    menu.style.left = `${rect.left}px`
    menu.style.top = `${rect.bottom + margin}px`
    menu.style.bottom = "auto"

    requestAnimationFrame(() => {
      const menuRect = menu.getBoundingClientRect()
      if (menuRect.bottom > window.innerHeight - 8) {
        menu.style.top = "auto"
        menu.style.bottom = `${window.innerHeight - rect.top + margin}px`
      }
      if (menuRect.right > window.innerWidth - 8) {
        menu.style.left = `${Math.max(8, rect.right - menuRect.width)}px`
      }
    })
  }

  _handleClickOutside(event) {
    if (!this.element.contains(event.target) && !this._menu.contains(event.target)) {
      this._close()
    }
  }

  disconnect() {
    this._close()
  }
}
